// Global cart store for Alpine.js
export function cartStore() {
  return {
    // State
    cartCount: window.cartCount || 0,
    sections: {},
    loading: false,

    // Initialize store
    init() {
      // Set initial count from server
      this.cartCount = window.cartCount || 0;

      document.addEventListener("rebuy:cart.change", (event) => {
        const items = event.detail.cart.getItems();
        const totalQuantity = items.reduce((acc, item) => acc + item.quantity, 0);
        this.cartCount = totalQuantity;
      });
    },

    // Actions
    async add(formData) {
      this.loading = true;

      try {
        // Make sure formData includes sections
        if (!formData.has("sections")) {
          const sections = window.ShopSuey.cart.getDefaultSections();
          formData.append("sections", sections.join(","));
        }

        // First add the item
        const response = await window.ShopSuey.cart.update({
          url: window.routes.cart_add_url,
          body: formData,
          context: this
        });

        // Then get the current cart state
        const cartState = await window.ShopSuey.cart.update({
          url: window.routes.cart_url + ".js"
        });

        // Update the count from the cart state
        this.cartCount = cartState.item_count;
        this.sections = response.sections || {};

        return response;
      } finally {
        this.loading = false;
      }
    },

    async remove(line) {
      this.loading = true;
      try {
        const response = await window.ShopSuey.cart.update({
          url: window.routes.cart_change_url,
          body: {
            line,
            quantity: 0,
            sections: window.ShopSuey.cart.getDefaultSections()
          },
          context: this
        });

        // Get current cart state
        const cartState = await window.ShopSuey.cart.update({
          url: window.routes.cart_url + ".js"
        });

        this.cartCount = cartState.item_count;
        this.sections = response.sections || {};
        return response;
      } finally {
        this.loading = false;
      }
    },

    async updateQuantity(line, quantity) {
      this.loading = true;
      try {
        // Attempt the quantity update
        const response = await window.ShopSuey.cart.update({
          url: window.routes.cart_change_url,
          body: {
            line,
            quantity,
            sections: window.ShopSuey.cart.getDefaultSections()
          },
          context: this
        });

        // If we got an error response, return it directly with our custom message for 422
        if (response?.errors || response?.status === 422) {
          return {
            errors: window.theme.translations.cart.errors.inventory_limit,
            status: 422
          };
        }

        // Update our local state
        this.cartCount = response.item_count;
        this.sections = response.sections || {};
        return response;
      } catch (error) {
        // Handle 422 responses gracefully with our custom message
        if (error?.status === 422 || error?.response?.status === 422) {
          return {
            errors: window.theme.translations.cart.errors.inventory_limit,
            status: 422
          };
        }

        // Return other errors in a structured format
        return {
          errors: error.message || window.theme.translations.cart.general.cart_quantity_error,
          status: error.status || 500
        };
      } finally {
        this.loading = false;
      }
    }
  };
}
